/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Tab_SalaryInputs */

const en_landing_tab_salary = /** @type {(inputs: Landing_Tab_SalaryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Salary Intel`)
};

const de_landing_tab_salary = /** @type {(inputs: Landing_Tab_SalaryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gehalts-Intel`)
};

const fr_landing_tab_salary = /** @type {(inputs: Landing_Tab_SalaryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Salary Intel`)
};

const es_landing_tab_salary = /** @type {(inputs: Landing_Tab_SalaryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Salary Intel`)
};

const it_landing_tab_salary = /** @type {(inputs: Landing_Tab_SalaryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Salary Intel`)
};

const nl_landing_tab_salary = /** @type {(inputs: Landing_Tab_SalaryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Salary Intel`)
};

const pl_landing_tab_salary = /** @type {(inputs: Landing_Tab_SalaryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Salary Intel`)
};

const fi_landing_tab_salary = /** @type {(inputs: Landing_Tab_SalaryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Salary Intel`)
};

const da_landing_tab_salary = /** @type {(inputs: Landing_Tab_SalaryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Salary Intel`)
};

const sv_landing_tab_salary = /** @type {(inputs: Landing_Tab_SalaryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Salary Intel`)
};

/**
* | output |
* | --- |
* | "Salary Intel" |
*
* @param {Landing_Tab_SalaryInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const landing_tab_salary = /** @type {((inputs?: Landing_Tab_SalaryInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Tab_SalaryInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_landing_tab_salary(inputs)
	if (locale === "fr") return fr_landing_tab_salary(inputs)
	if (locale === "es") return es_landing_tab_salary(inputs)
	if (locale === "it") return it_landing_tab_salary(inputs)
	if (locale === "nl") return nl_landing_tab_salary(inputs)
	if (locale === "pl") return pl_landing_tab_salary(inputs)
	if (locale === "fi") return fi_landing_tab_salary(inputs)
	if (locale === "da") return da_landing_tab_salary(inputs)
	if (locale === "sv") return sv_landing_tab_salary(inputs)
	return en_landing_tab_salary(inputs)
});